import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ButtonBar, DebtorList, NoAssetsDisplay, ScreenHeader
} from '../../components';
import { DebtorsContext, DebtorsProvider } from '../../context/debtors.provider';


export function NewWillDebtForgivenessScreen() {
  return (
    <DebtorsProvider>
      <NewWillDebtForgivenessScreenContent />
    </DebtorsProvider>
  );
}

export function NewWillDebtForgivenessScreenContent() {
  const navigate = useNavigate();

  const { debtors } = React.useContext(DebtorsContext);

  const handleBack = useCallback(() => {
    navigate('../pet-arrangements');
  }, [ navigate ]);

  const handleContinue = useCallback(() => {
    navigate('../executors');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    navigate('../add-debtor');
  }, [ navigate ]);

  return (
    <div className="new-will-debt-forgiveness-screen">
      <ScreenHeader 
        title="Debt Forgiveness"
        description="Who should have their debts forgiven?"
        handleBack={handleBack} 
        steps={6} 
        step={4} 
      />
      
      {
        !debtors.length ? (
          <div style={{ paddingTop: '64px' }}>
            <NoAssetsDisplay
              icon="money_off"
              title="Let's add your debtors"
              description="To ensure fair distribution, please provide details of any debts to be forgiven."
            />
          </div>
        ) : (
          <DebtorList debtors={debtors} />
        )
      }

      <ButtonBar 
        handleSecondary={handleContinue}
        secondaryText={debtors.length > 0 ? 'Continue' : 'Skip'}
        handlePrimary={handleNext}
        primaryText="Add Debtor"
      />
    </div>
  );
}






